// Search caps each page at 100. Fetch the already loaded window before
// publishing it, so a background refresh cannot empty cards further down.
export async function loadAssetRefreshWindow(request, params, loadedCount) {
    const perPage = Math.min(100, Math.max(25, loadedCount));
    const first = await request({...params, page: 1, per_page: perPage});
    if(first.data.error || !first.data.assets) return first;
    const assets = [...first.data.assets];
    const count = Math.min(loadedCount, first.data.total_entries ?? loadedCount);
    for(let page = 2; assets.length >= (page - 1) * perPage && (page - 1) * perPage < count; page++) {
        const next = await request({...params, page, per_page: perPage, include_totals: false});
        if(next.data.error) throw new Error(String(next.data.error));
        assets.push(...(next.data.assets || []));
    }
    return {...first, data: {...first.data, assets}};
}
